import {RegisterLogin} from '../register-login';
import '../../../js-lib/mailcheck.min.js';
import {setupRegistrationForm} from '~/auth/register/form';

window.evite.when('document.ready').then(() => {
  const domains = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'aol.com',
    'comcast.net',
    'sbcglobal.net',
    'msn.com',
    'verizon.net',
    'facebook.com',
    'att.net',
    'cox.net',
    'bellsouth.net',
    'evite.com',
    'me.com',
    'live.com',
    'earthlink.net',
    'mac.com',
    'charter.net',
    'optonline.net',
    'ymail.com',
    'shaw.ca',
    'rogers.com',
    'yahoo.ca',
    'juno.com',
    'sympatico.ca',
    'icloud.com',
    'aim.com',
    'telus.net',
    'rocketmail.com',
    'roadrunner.com',
    'q.com',
  ];
  const secondLevelDomains = ['hotmail', 'yahoo', 'aol'];
  const topLevelDomains = ['com', 'net', 'org', 'ca'];
  const $hint = $('#hint');
  const $email = $('#id_email');
  //            var superStringDistance = function(string1, string2) {
  //              // a string distance algorithm of your choosing
  //            };
  $email.on('blur', function () {
    $hint.css('display', 'none').empty();
    $(this).mailcheck({
      domains, // optional
      secondLevelDomains, // optional
      topLevelDomains, // optional
      suggested(element, suggestion) {
        if (!$hint.html()) {
          // First error - fill in/show entire hint element
          var suggestion =
            `Did you mean <span class='suggestion'>` +
            `<span class='address'>${suggestion.address}</span>` +
            `@<a href='#' class='domain'>${suggestion.domain}</a></span>?`;

          $hint.html(suggestion).fadeIn(150);
        } else {
          // Subsequent errors
          $('.address').html(suggestion.address);
          $('.domain').html(suggestion.domain);
        }
      },
    });
  });
  $email.on('focusin', () => {
    $hint.css('display', 'none').empty();
  });
  $hint.on('click', '.domain', () => {
    // On click, fill in the field with the suggestion and remove the hint
    $email.val($('.suggestion').text());
    $hint.fadeOut(200, function () {
      $(this).empty();
    });
    return false;
  });

  setupRegistrationForm();
  new RegisterLogin();
});

window.evite.when('window.load').then(() => {
  // Reveal back-end error(s) after page load to trigger aria-alert
  if (document.querySelector('.error-message')) {
    document.querySelector('.error-message').style.visibility = 'visible';
  }
});
